import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Checkbox,
  Grid,
  TableContainer,
  Paper,
  TableHead,
  TableCell,
  TableRow,
  Table,
  TableBody,
  CircularProgress,
} from "@mui/material";
import useGetTokenDetails from "../Hooks/GetTokenDetails";
import CustomDatePicker from "../Components/DatePicker";
import Disclaimer from "../Components/Disclaimer";
import { useLocation } from "react-router-dom";
import {
  getLockDetailsById,
  updateLockHandler,
} from "../ContractAction/TrendLockAction";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { getTokenDecimals } from "../ContractAction/ContractDependency";
import { FairLaunchTheme } from "../LaunchPad/CeateFairLaunch/FairLaunchTheme";

const EditLock = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const tokenAddress = location.state.tokenAddress; // Extract tokenAddress from the location state
  const lockId = location.state.lockId;
  console.log("tokenAddress_lockId", tokenAddress, lockId);
  const [tokenDetails, setTokenDetails] = useState();
  const [lockDetails, setLockDetails] = useState();
  const [amountLocked, setAmountLocked] = useState();
  const [unLoclDate, setUnLoclDate] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [hasDecimalError, setHasDecimalError] = useState(false);
  const [decimals, setDecimals] = useState(18); // default to 18

  useEffect(() => {
    const fetchTokenDecimals = async () => {
      if (tokenAddress) {
        const decimals = await getTokenDecimals(tokenAddress);
        setDecimals(decimals);
      }
    };

    fetchTokenDecimals();
  }, [tokenAddress]);
  const fetchTokenDetails = useGetTokenDetails(); // Get the function, not data
  useEffect(() => {
    if (tokenAddress) {
      fetchTokenDetails(tokenAddress).then(setTokenDetails);
    } else {
      setTokenDetails(null);
    }
  }, [tokenAddress]);
  useEffect(() => {
    async function fetchDetails() {
      try {
        const lockDetails = await getLockDetailsById(lockId, decimals);
        console.log("12345", lockDetails);
        setLockDetails(lockDetails);
        setAmountLocked(lockDetails?.amountLocked);
        setUnLoclDate(dayjs(lockDetails?.tgedate)); // Convert to Dayjs
      } catch (error) {
        console.error("Error fetching lock details:", error);
      }
    }
    fetchDetails();
  }, [lockId, decimals]);

  const UpdateLockClick = async () => {
    try {
      if (!amountLocked) {
        toast.error("Enter amount");
      } else {
        setIsLoading(true);
        const tx = await updateLockHandler(
          amountLocked,
          unLoclDate,
          lockDetails?.lockId,
          tokenAddress
        );
        console.log("Transaction", tx);

        // Check if the transaction is successful
        if (tx) {
          toast("Lock Updated!", {
            icon: "✅",
            type: "success",
          });
          navigate(-1);
        } else {
        }
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error updating lock:", error);
      setIsLoading(false);
    }
  };
  const handleAmountChange = (e) => {
    const input = e.target.value;
    if (input === "" || input <= 0) {
      setAmountLocked("");
      setHasDecimalError(false);
      return;
    }
    if (!/^\d*\.?\d*$/.test(input)) return;
    const [intPart, decimalPart] = input.split(".");
    if (decimalPart && decimalPart.length > 18) {
      setHasDecimalError(true);
    } else {
      setHasDecimalError(false);
    }
    setAmountLocked(input);
  };
  return (
    <Container maxWidth="md">
      <Box
        className="flex-col gap-16"
        sx={(theme) => ({
          ...FairLaunchTheme.cardStyle(theme),
          padding: "32px",
          marginTop: "40px",
        })}
      >
        <div style={{ textAlign: "center" }}>
          <Typography
            variant="h4"
            sx={(theme) => FairLaunchTheme.gradientText(theme)}
            fontWeight="700"
          >
            Edit Your Lock
          </Typography>
        </div>
        <div sx={{ padding: "20px 0" }}>
          <Grid item xs={12}>
            <Box sx={{ overflowX: "auto", maxWidth: "100%" }}>
              <TableContainer
                component={Paper}
                sx={(theme) => ({
                  background: "transparent",
                  boxShadow: "none",
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: "16px",
                  "& .MuiTableCell-root": {
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    color: theme.palette.text.primary,
                  },
                })}
              >
                <Table sx={{ minWidth: 600 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={(theme) => ({
                          fontWeight: "bold",
                          textAlign: "center",
                          padding: "16px",
                          color: "#1D64FA", // Brand color for header
                          fontSize: "1rem",
                        })}
                      >
                        Property
                      </TableCell>
                      <TableCell
                        sx={(theme) => ({
                          fontWeight: "bold",
                          textAlign: "center",
                          padding: "16px",
                          color: "#1D64FA",
                          fontSize: "1rem",
                        })}
                      >
                        Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {[
                      { label: "Token Name", value: tokenDetails?.name },
                      { label: "Token Symbol", value: tokenDetails?.symbol },
                      { label: "Decimals", value: tokenDetails?.decimals },
                      {
                        label: "Total Supply",
                        value: tokenDetails?.totalSupply,
                      },
                      { label: "Balance", value: tokenDetails?.balance },
                    ].map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          sx={{
                            textAlign: "center",
                            padding: "16px",
                            color: (theme) => theme.palette.text.secondary,
                          }}
                        >
                          {row.label}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            padding: "16px",
                            fontWeight: "500",
                          }}
                        >
                          {row.value || "-"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </div>

        <Box className="flex-col gap-8">
          <Typography
            variant="h6"
            sx={{
              color: (theme) => theme.palette.text.primary,
              fontWeight: 600,
            }}
          >
            Amount
          </Typography>
          <TextField
            sx={(theme) => FairLaunchTheme.inputStyle(theme)}
            variant="outlined"
            value={amountLocked}
            onChange={handleAmountChange}
            placeholder="0"
            error={hasDecimalError}
            helperText={
              hasDecimalError ? "Maximum 18 decimal places allowed" : ""
            }
            fullWidth
            InputProps={{
              sx: { color: "#fff", padding: "10px" },
            }}
          />
        </Box>

        <Box className="flex-col gap-8">
          <Typography
            variant="h6"
            sx={{
              color: (theme) => theme.palette.text.primary,
              fontWeight: 600,
            }}
          >
            Unlock Date
          </Typography>
          <CustomDatePicker
            value={unLoclDate}
            onChange={(newValue) => setUnLoclDate(dayjs(newValue))}
          />
        </Box>

        <div
          className="flex justify-center items-center"
          style={{ marginTop: "24px" }}
        >
          <Button
            variant="contained"
            sx={(theme) => ({
              ...FairLaunchTheme.neonButton(theme),
              padding: "12px 40px",
              fontSize: "16px",
              fontWeight: "700",
              width: "200px",
              height: "56px",
            })}
            onClick={isLoading ? null : UpdateLockClick}
          >
            {isLoading ? (
              <CircularProgress size={24} sx={{ color: "#fff" }} />
            ) : (
              "Update Lock"
            )}
          </Button>
        </div>
      </Box>
      <Disclaimer />
    </Container>
  );
};

export default EditLock;
